<template>
    <div class="redirect-page">
    <div class="tips">正在跳转企微入群页面...</div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            
        }
    },
    mounted() {
    const targetUrl = "https://work.weixin.qq.com/gm/0765206764e858e79ac673052076c975";
    // 延迟跳转，防止部分浏览器拦截
    setTimeout(() => {
      window.location.href = targetUrl;
    }, 300);
  }
}
</script>

<style scoped>
.redirect-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tips {
  font-size: 16px;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/view/redirect.vue